<template>
    <v-container 
        :fluid="!!$mq.phone" 
        class="services py-10"  
    >
        <v-row justify="center">
            <v-col 
                v-for="item in items" 
                :key="`service-${ item.label }`"
                :cols="cols"
                class="d-flex flex-column py-0 mb-3"
            >
                <v-card 
                    tile
                    class="service flex-grow-1 d-flex flex-column custom-white"
                    :class="!!$mq.phone ? 'service-sm' : ''"
                    :style="{ backgroundImage: `url( ${ require(`@/assets/img/agrégat-compacté${ !!$mq.phone ? '-sm' : '' }.jpg`) } )` }"
                >
                    <v-card-title class="d-flex flex-column pt-10 semi-white">
                        <v-avatar color="#2D2A29" size="62" class="mb-5">
                            <v-icon x-large color="white">mdi-{{ item.avatar.icon }}</v-icon>
                        </v-avatar>

                        <h2 class="text-center">{{ item.title }}</h2>
                    </v-card-title>

                    <v-card-text class="flex-fill semi-white px-10" >
                        <p 
                            v-for="(paragraph, i) in item.text" 
                            :key="`service-${ item.label }-${ i }`" 
                            v-html="paragraph"
                            :class="i === item.text.length - 1 ? 'ma-0' : ''"
                        />
                    </v-card-text>

                    <v-card-actions 
                        v-if="!!item.action"
                        class="justify-center pb-10 semi-white"
                    >
                        <CTABtn :item="item.action" />
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CTABtn from '@/components/CTABtn'

export default {
    name: 'Services',
    props: [
        'screen'
    ],
    components: {
        CTABtn
    },
    computed: {
        cols() {
            return this.screen.width > 1600 ? 3 : 
                this.screen.width > 1200 ? 4 :
                this.screen.width > 900 ? 8 : 12
        }
    },
    data() {
        return {
            background: require(`@/assets/img/pise-background.jpg`),
            items: [
                {
                    label: 'structures',
                    title: 'Structures',
                    text: [
                        `Nos structures de pisé stabilisé se prêtent à tous vos projets de construction 
                        et d'aménagement d'espaces intérieurs et extérieurs.`,

                        `Optez pour notre savoir-faire afin d'assurer la qualité, l'efficacité 
                        et le caractère unique de chacun d'eux.`,
                    ],
                    avatar: {
                        color: null,
                        icon: 'hammer-wrench',
                    },
                    action: {
                        label: 'learn',
                        title: 'En savoir plus',
                        prependIcon: 'information-outline',
                        to: {
                            path: '/',
                            hash: '#structures',
                        },
                    }
                },
                {
                    label: 'furniture',
                    title: 'Mobilier urbain',
                    text: [
                        `Créations en pisé stabilité moulé, toutes uniques de par l’agencement des 
                        matériaux qui les composent.`,
                        `Choisissez parmis nos différents modèles ou faites-nous part de vos besoins!`,
                    ],
                    avatar: {
                        color: null,
                        icon: 'fireplace-off',
                    },
                    action: {
                        label: 'learn',
                        title: 'En savoir plus',
                        prependIcon: 'information-outline',
                        to: {
                            path: '/',
                            hash: '#urban-furniture'         
                        },
                    }
                },
                {
                    label: 'classes',
                    title: 'Formation',
                    text: [
                        `Participez à une de nos session de formation et apprenez-en davantage sur 
                        le pisé stabilisé, ses multiples applications et ses avantages.`,
                    ],
                    avatar: {
                        color: null,
                        icon: 'teach',
                    },
                    action: {
                        label: 'contact',
                        title: 'Contactez-nous',
                        prependIcon: 'forum-outline',
                        to: {
                            path: '/',
                            hash: '#contact',
                        },
                    }
                }
            ]
        }
    },
    methods: {        
        run( method, params = null ) {
            if( typeof this[ method ] === 'function' ) {
                !!params ? this[ method ]( params ) : this[ method ]()
            }
            else {
                this.$emit( 'run', method, params )
            }
        },
    },
  }
</script>

<style scoped>
.service {
    /* border: 3px #2D2A29 solid; */
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
}

.service.service-sm {
    background-attachment: scroll !important;
}
</style>
